// extracted by mini-css-extract-plugin
module.exports = {"text-large":"16px","label":"compose-module--label--edd780","searchInput":"Search-module--searchInput--e8415c","search":"Search-module--search--3a82b3"};